export default "__VITE_PUBLIC_ASSET__524b386f__"